class HeaderContactButton extends HTMLElement {
  constructor() {
    super();
    this.closeTimeout = null;
    this.panel = this.querySelector('.header__contact-panel');
  }

  connectedCallback() {
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.closeTimeout);
      this.panel.style.display = 'block';
    });

    this.addEventListener('mouseleave', () => {
      this.closeTimeout = setTimeout(() => {
        this.panel.style.display = '';
      }, 300);
    });

    this.addEventListener('focusin', () => {
      clearTimeout(this.closeTimeout);
      this.panel.style.display = 'block';
    });

    this.addEventListener('focusout', (e) => {
      if (!this.contains(e.relatedTarget)) {
        this.panel.style.display = '';
      }
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.panel.style.display = '';
      }
    });
  }
}

customElements.define('header-contact-button', HeaderContactButton);
